import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { useI18n } from 'vue-i18n';
import ListLoadingPlaceholder from '@/components/ListLoadingPlaceholder.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'TokenListPlaceholder',
  props: {
    action: null
  },
  setup(__props: any) {

const props = __props as {
  action: string;
}

const { t } = useI18n();

const captions = [
  {
    caption: t('singleSide.portfolio.caption'),
    tooltip: t('singleSide.portfolio.tooltip'),
  },
  {
    caption: t('singleSide.apr.caption'),
    tooltip: t('singleSide.apr.tooltip'),
  },
  {
    caption: t('singleSide.noFeeLimit.caption'),
    tooltip: t(`singleSide.noFeeLimit.tooltip.${props.action}`),
  },
];

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(ListLoadingPlaceholder, {
      captions: captions,
      count: "4"
    })
  ]))
}
}

})